import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import zh from "vee-validate/dist/locale/zh_CN"; //引入中文文件

// 配置中文
Validator.localize("zh_CN", zh);

const config = {
  //   errorBagName: 'error',
  fieldsBagName: "fieldBags", //"fileds" 与Vant的表单组件名称冲突
  locale: "zh_CN",
  delay: 0,
  messages: null,
  strict: true,
  event: "input",
  inject: true
};

Vue.use(VeeValidate, config);

// 自定义validate
const dictionary = {
  zh_CN: {
    messages: {
      email: () => "请输入正确的邮箱格式",
      phone: () => "请输入正确的手机号码",
      vertifyCode: () => "请输入正确的验证码",
      name: () => "请输入正确的姓名",
      idcode: () => "请输入正确的证件号",
      required: field => "请输入" + field,
      foidortnum: () => "请输入正确的证件号码/票号",
      tkNo: () => "请输入正确的票号",
      ticketnumber: () => "请输入正确的票号",
      nameen: () => "请输入正确的英文名",
      staffno: () => "请输入正确的OA账号",
      passport: () => "护照姓名为XX/XX",
      IDNumbers: () => "请输入正确证件号",
      peer: () => "请输入姓名",
      ImageVerifyCode: () => "请输入图片验证码"
    },
    attributes: {
      email: "邮箱",
      password: "密码",
      name: "姓名",
      phone: "手机",
      vertifyCode: "验证码",
      peer: "姓名",
      idcode: "证件号",
      foidortnum: "证件号码/票号",
      birthday: "生日",
      expireDate: "证件有效期",
      validitydate: "有效期",
      ticketnumber0: "票号",
      name0: "姓名",
      ticketnumber1: "票号",
      name1: "姓名",
      ticketnumber2: "票号",
      name2: "姓名",
      ticketnumber3: "票号",
      name3: "姓名",
      ticketnumber4: "票号",
      name4: "姓名",
      ticketnumber5: "票号",
      name5: "姓名",
      addrdetail: "详细地址",
      namefc: "中文名",
      namesc: "中文姓",
      namefe: "英文名",
      namese: "英文姓",
      staffno: "OA账号",
      IDNumbers: "证件号",
      ticketnumber: "票号",
      ImageVerifyCode: "验证码",
      peer: "乘机人"
    }
  }
};

Validator.localize(dictionary);

Validator.extend("phone", {
  getMessages: field => field + "必须是11位手机号码",
  validate: value => {
    return value.length == 11 && /^1[3-9]{1}\d{9}$/.test(value);
  }
});
Validator.extend("peer", {
  getMessages: field => field + "必须是中文汉字",
  validate: value => {
    if (value) {
      return true;
    } else {
      return false;
    }
  }
});

Validator.extend("name", {
  getMessages: field => field + "必须是中文汉字",
  validate: value => {
    return /^[\u4e00-\u9fa5]+$/.test(value);
  }
});

Validator.extend("idcode", {
  getMessages: field => field + "不正确",
  validate: value => {
    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value);
  }
});
Validator.extend("foidortnum", {
  getMessages: field => field + "必须是数字或字母",
  validate: value => {
    return /^[0-9a-zA-Z]+$/.test(value);
  }
});
Validator.extend("tkNo", {
  getMessages: field => field + "必须是数字或字母",
  validate: value => {
    return /^[0-9a-zA-Z]+$/.test(value);
  }
});
Validator.extend("peer", {
  getMessages: field => "请输入正确的姓名",
  validate: value => {
    if (!value) {
      return false;
    } else {
      return true;
    }
  }
});
Validator.extend("ticketnumber", {
  getMessages: field => field + "必须是数字",
  validate: value => {
    return /^(891|891-)\d{10}$/.test(value);
  }
});
Validator.extend("nameen", {
  getMessages: field => field + "必须是字母",
  validate: value => {
    return /^[a-zA-Z]+$/.test(value);
  }
});
Validator.extend("staffno", {
  getMessages: field => field + "必须是数字或字母",
  validate: value => {
    return /^[0-9a-zA-Z]+$/.test(value);
  }
});
Validator.extend("passport", {
  getMessages: field => field + "必须是字母",
  validate: value => {
    return /^([a-zA-Z]{2,})\/([a-zA-Z]{2,})$/.test(value);
  }
});
Validator.extend("IDNumbers", {
  getMessages: field => field + "必须是数字或字母",
  validate: value => {
    return /^[0-9a-zA-Z]+$/.test(value);
  }
});
Validator.extend("email", {
  getMessages: field => field + "不正确",
  validate: value => {
    return /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/.test(value);
  }
});



// WEBPACK FOOTER //
// ./src/assets/js/validate.js